export default {
      id: "icon-de-usage",
      viewBox: "0 0 22 13",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-de",
      toString: function () {
        return this.url;
      }
    }